import { Capacitor } from '@capacitor/core'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'
import { useMediaQuery } from 'usehooks-ts'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { mixpanel } from '@/mixpanel'
import { useNavigate } from '@/router-wrapper'
import { StButtonContainer, StContainer, StContent, StDesktopButtonContainer } from './DeeplinkNotFound.styled'

type DeeplinkNotFoundProps = {
  origin: string
}

export const DeeplinkNotFound = ({ origin }: DeeplinkNotFoundProps) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.toS)
  const isNative = Capacitor.isNativePlatform()
  const isMobile = isNative || isSmallScreen
  const navigate = useNavigate()

  useHideNativeNavigation()

  const handleClose = () => {
    mixpanel.track('deeplink_not_found_closed', { origin })

    navigate(`/${origin}`)
  }

  return (
    <StContainer>
      <StContent>
        <FlexColumn gap={theme.UI.Spacing.Space4}>
          <H2 noMargin>Wat je zoekt is niet (meer) beschikbaar</H2>
          <FlexColumn>
            <Span type='BodyMediumRegular'>
              {t({
                id: 'deeplink-not-found.description1',
                message: 'Het is mogelijk dat het door je zorgverlener verwijderd is.',
              })}
            </Span>
            <Margin mb={theme.UI.Spacing.Space3} />
            <Span type='BodyMediumRegular'>
              {t({
                id: 'deeplink-not-found.description2',
                message: 'Twijfel je of verwachtte je iets anders? Neem dan contact op met je zorgteam.',
              })}
            </Span>
          </FlexColumn>
        </FlexColumn>
      </StContent>

      {isMobile ? (
        <StButtonContainer>
          <Button variant='Primary' onClick={handleClose}>
            {t({
              id: 'globals.close',
              message: 'Sluiten',
            })}
          </Button>
        </StButtonContainer>
      ) : (
        <StDesktopButtonContainer>
          <Button variant='Primary' onClick={handleClose}>
            {t({
              id: 'globals.close',
              message: 'Sluiten',
            })}
          </Button>
        </StDesktopButtonContainer>
      )}
    </StContainer>
  )
}
